/**
 * Created by JasonChou on 16/6/6.
 */

import {LOGIN_SUCCESS} from '../mutationTypes'

const state = {
  mineInfo: {},

  settings: {},

  register: {
    phone: '',
    password: '',
    captcha: '',
    country: ''
  }
};

// mutations
const mutations = {
  [LOGIN_SUCCESS] (state, userInfo, settings) {
    state.mineInfo = userInfo;
    state.settings = settings;
  }
};

export default {
  state,
  mutations
}



/** WEBPACK FOOTER **
 ** ./src/store/modules/auth.js
 **/